var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"bg-light min-vh-100 py-4",attrs:{"id":"app"}},[_c('div',{staticClass:"container"},[_c('StockHeader'),_c('div',{staticClass:"row g-4 mb-4"},[_c('div',{staticClass:"col-lg-6"},[_c('StockForm')],1),_c('div',{staticClass:"col-lg-6"},[_c('StockStats')],1)]),_c('StockFilter'),_c('StockList'),_c('StockCart')],1)])
}
var staticRenderFns = []

export { render, staticRenderFns }